import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const dayTranslations = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const WeekHeader = () => {
  const $ = _c(5);
  const {
    t
  } = useTranslation("ui");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      gridTemplateColumns: "repeat(7, 40px)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = dayTranslations.map(day => <div key={day} className="flex items-center justify-center"><p className="text-caption-1 text-tertiary">{t(`global.days-short.${day}`, {
          defaultValue: day
        })}</p></div>);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="grid grid-cols-7 gap-0 mx-auto h-7" style={t0}>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default WeekHeader;